import { Text } from '@doda/io-react/common';

import { FC } from 'react';
import {
  TAB_JOBDETAIL,
  TAB_PHOTOS,
} from '@doda/common/src/constants/properties/const';
import styles from './index.module.scss';
import { LinkList } from './LinkList';
import { useTab } from '../TabArea/hooks/useTab';
import { Tab } from '../../types/tab';
import { createRelationLinkProps } from './logics/createRelationLinkProps';

/**
 * RelationLinkのprops
 */
interface Props {
  relationLinkProps: ReturnType<
    typeof createRelationLinkProps
  >['relationLinkProps'];
  initialTab: Tab;
  jid: string;
  wcnsId: string;
}

/**
 * この求人に似た求人を探す
 */
export const RelationLink: FC<Props> = ({
  relationLinkProps,
  initialTab,
  jid,
  wcnsId,
}) => {
  const { currentTabName } = useTab({
    initialTab,
    jid,
    wcnsId,
  });
  const { occupation, area, location, station, industry } = relationLinkProps;
  if (currentTabName !== TAB_JOBDETAIL && currentTabName !== TAB_PHOTOS)
    return null;

  return (
    <section className={styles['jobSearchDetail-relationLink']}>
      <Text as="h2" color="black_pc" size="20" weight="bold">
        この求人に似た求人を探す
      </Text>
      <ul className={styles['jobSearchDetail-relationLink__body']}>
        {[occupation, area, location, station, industry].map(
          ({ label, linkList }) => {
            if (!linkList.list.length) return null;
            return (
              <li
                key={label}
                className={styles['jobSearchDetail-relationLink__category']}
              >
                <Text
                  as="p"
                  color="black_pc"
                  className={
                    styles['jobSearchDetail-relationLink__categoryTitle']
                  }
                >
                  {label}
                </Text>
                <LinkList linkList={linkList} />
              </li>
            );
          }
        )}
      </ul>
    </section>
  );
};
